// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"887":"22c329c9","934":"b36814a8"}[chunkId] + ".chunk.js";
};